import { render, staticRenderFns } from "./PaginatedCreationList.vue?vue&type=template&id=34ac0238"
import script from "./PaginatedCreationList.vue?vue&type=script&lang=ts"
export * from "./PaginatedCreationList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports